module.exports = __webpack_public_path__ + "img/cons_6.d37f940e.jpg";